<div class="wrapper">
  <!--  WORK DAY  — same block, position and treatment as the daily report's
        workday header. Holds the day-level fields (diary date + "Contractor
        was working on this day"). -->
  <div
    (click)="$event.stopPropagation(); triggerOpenPanel('workday')"
    class="workday-header flex items-center gap-[12px] cursor-pointer pb-[20px]"
    data-testid="diary-workday-header"
  >
    <span class="workday-label">{{ workdayLabel }}</span>
    <span class="workday-date text-type-10">{{ diary?.diary_date | date : 'MMMM d, y' }}</span>
    <mat-icon class="workday-edit-icon" svgIcon="pencil-outline" />
  </div>

  <!--  WEATHER  -->
  <app-daily-report-expandable-block
    (click)="handleExpansion('weather')"
    [isExpanded]="expandedSection === 'weather'"
    [subheading]="weatherSummary"
    componentString="diary-weather"
    heading="Weather"
    icon="daily-report-weather"
    id="diary-weather"
    data-testid="diary-weather-block"
  >
    <ng-container>
      @if (hasWeather) {
        <div (click)="$event.stopPropagation()" class="panel weather-panel">
          <app-weather-summary
            (click)="triggerOpenPanel('weather')"
            [data]="weather"
          />
        </div>
      } @else {
        <div (click)="$event.stopPropagation(); triggerOpenPanel('weather')" class="no-data cursor-pointer">
          No weather added.
        </div>
      }
    </ng-container>
  </app-daily-report-expandable-block>
  <hr class="divider" />

  <!--  REMARKS  -->
  <app-daily-report-expandable-block
    (click)="handleExpansion('remarks')"
    [isExpanded]="expandedSection === 'remarks'"
    [itemCount]="remarksCount"
    [subheading]="remarksCount + (remarksCount === 1 ? ' entry' : ' entries')"
    componentString="diary-remarks"
    heading="Remarks"
    icon="daily-report-activity"
    id="diary-remarks"
    data-testid="diary-remarks-block"
  >
    <ng-container>
      @if (remarkCards.length) {
        <!-- One card per remark; clicking one opens a panel holding just that
             entry, exactly as the report's Remarks section does. -->
        <div (click)="$event.stopPropagation()" class="panel remarks-panel">
          @for (card of remarkCards; track card.uuid) {
            <app-activity-summary
              (click)="triggerOpenPanel('remark', card.uuid)"
              [class.selected]="card.uuid === selectedRemarkUuid"
              [data]="card"
            />
          }
        </div>
      } @else {
        <div (click)="$event.stopPropagation(); triggerOpenPanel('remark')" class="no-data cursor-pointer">
          No remarks data available.
        </div>
      }
    </ng-container>
  </app-daily-report-expandable-block>
</div>
